import { linkedin, x, contact1 } from "../assets";


export const navLinks = [
  {
    id: "home",
    title: "Home",
    href: "/",
  },
  {
    id: "about",
    title: "About",
    href: "/about",
  },
  {
    id: "publication",
    title: "Publications",
    href: "/publication", 
  },

  {
    id: "contact",
    title: "Contact",
    href: "/contact",
  },
];

export const features = [
  {
    id: "feature-1",
    image: contact1,
    title: "Financial Infrastructure",
    subtitle: "Expanding access through better infrastructure.",
    content:
      "Payments, remittances, lending, neobanks, insurtech, embedded finance. Alternative credit scoring. Mobile first.",
  },
  {
    id: "feature-2",
    image: contact1,
    title: "Social commerce",
    subtitle: "Turning trust into distribution.",
    content:
      "P2P marketplaces. Influencer and affiliate selling. WhatsApp and voice commerce. Localized logistics. ",
  },
  {
    id: "feature-3",
    image: contact1,
    title: "Creator Economy",
    subtitle: "Tools for creative sovereignty.",
    content:
      "Monetization (subscriptions, tipping, storefronts). IP and rights management. Community tech. Upskilling Africa’s digital creatives.",
  },
  {
    id: "feature-4",
    image: contact1,
    title: "AI",
    subtitle: "AI Solving local problems for global relevance.",
    content:
      "AI in health, agriculture, finance, governance. African language models. Data annotation. Ethical, culturally aligned AI.",
  },
  {
    id: "feature-5",
    image: contact1,
    title: "Moonshots & Frontier Tech",
    subtitle: "Bold bets on breakthrough tech",
    content:
      "Clean energy & climate resilience. Space & satellite infrastructure. Biotech, biofabrication, deep tech.",
  },
];

export const stats = [
  {
    id: "stats-1",
    title: "Our firm belief in the Promise of Africa drives our mission to resource, cultivate and elevate the next generation of disruptive, tech-driven startups owned and led by visionary African entrepreneurs.", 
  },
];

export const footerLinks = [
  {
    title: "Engage",
    links: [
      {
        name: "Home",
        href: "/",
      },
      {
        name: "About",
        href: "/about",
      },
      {
        name: "Publication",
        href: "/publication",
      },
      {
        name: "Contact",
        href: "/contact",
      },
    ],
  },
  {
    title: "Investment",
    links: [
      {
        name: "Partner",
        href: "/contact",
      },
      {
        name: "Founder",
        href: "/contact",
      },
    ],
  },
];

export const socialMedia = [
  {
    id: "social-media-1",
    title: "Linkedin",
    icon: linkedin,
    link: "https://www.linkedin.com/in/afrinextventures",
  },
  {
    id: "social-media-2",
    title: "X",
    icon: x,
    link: "https://www.x.com/@afrinextventures",
  },  
];

export const creator = [
  {
    id: "github.com/Ndwigar",
    link: "https://github.com/Ndwigar",
    title: "Ndwiga",
  },
];

export const experiences = [
  {
    title: "Sales",
    date: "March 2020 - Present",
    points: [
      "We understand that every project is unique and we take pride in our ability to tailor our solutions to meet specific needs of our clients with integrity and excellence.",
    ],
  },
  {
    title: "Procurement",
    date: "Jan 2021 - Present",
    points: [
      "With deep insights into the unmet clinical needs in Kenya, HSL aims to provide You with comprehensive healthcare solutions and support.",
    ],
  },
  {
    title: "Specialists",
    date: "Jan 2022 - Present",
    points: [
      "We beleive in the power of engineering to transform ideas into tangible realities.",
      "We are driven by a passion for delivering exceptional, structural and mechanical solutions that exceed expectations",
    ]
  },
  {
    title: "Other Services",
    date: "Present",
    points: [
      "HSL has a technical service team that supports its products, from in-service training through to complete operating table rebuilds.",
      "HSL installs equipment, lights, pendants, digital integration, sterilizers Dental, Medical Gases and more.",
      "Also project manages complete medical fit-outs.",
    ],
  },
];




